import { Injectable, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import { Charge } from '../../models/entities/charge';

@Pipe({
    name: 'chargeStatus',
    standalone: true,
})
@Injectable({
    providedIn: 'root',
})
export class ChargeStatusPipe implements PipeTransform
{
    public transform(charge: Charge) {
        if (charge.paid) {
            return 'paid';
        }

        if (charge.deletedAt) {
            return 'deleted';
        }

        const timezone = LegFiJwtService.getTimezone();
        const now = moment();
        const activeAfter = moment.utc(charge.activeAfter, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        const paymentDueOn = moment.utc(charge.paymentDueOn, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        if (paymentDueOn < now) {
            return 'overdue';
        } else if (activeAfter > now) {
            return 'future';
        } else if (charge.paymentsSum > 0) {
            return 'partial';
        } else {
            return 'current';
        }
    }
}
